/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AssessmentStatusCount
 */
export interface AssessmentStatusCount {
  /**
   *
   * @type {number}
   * @memberof AssessmentStatusCount
   */
  notStarted: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentStatusCount
   */
  pending: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentStatusCount
   */
  running: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentStatusCount
   */
  retry: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentStatusCount
   */
  failed: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentStatusCount
   */
  success: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentStatusCount
   */
  successWithErrors: number;
}

/**
 * Check if a given object implements the AssessmentStatusCount interface.
 */
export function instanceOfAssessmentStatusCount(value: object): value is AssessmentStatusCount {
  if (!('notStarted' in value) || value['notStarted'] === undefined) return false;
  if (!('pending' in value) || value['pending'] === undefined) return false;
  if (!('running' in value) || value['running'] === undefined) return false;
  if (!('retry' in value) || value['retry'] === undefined) return false;
  if (!('failed' in value) || value['failed'] === undefined) return false;
  if (!('success' in value) || value['success'] === undefined) return false;
  if (!('successWithErrors' in value) || value['successWithErrors'] === undefined) return false;
  return true;
}

export function AssessmentStatusCountFromJSON(json: any): AssessmentStatusCount {
  return AssessmentStatusCountFromJSONTyped(json, false);
}

export function AssessmentStatusCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentStatusCount {
  if (json == null) {
    return json;
  }
  return {
    notStarted: json['not_started'],
    pending: json['pending'],
    running: json['running'],
    retry: json['retry'],
    failed: json['failed'],
    success: json['success'],
    successWithErrors: json['success_with_errors'],
  };
}

export function AssessmentStatusCountToJSON(value?: AssessmentStatusCount | null): any {
  if (value == null) {
    return value;
  }
  return {
    not_started: value['notStarted'],
    pending: value['pending'],
    running: value['running'],
    retry: value['retry'],
    failed: value['failed'],
    success: value['success'],
    success_with_errors: value['successWithErrors'],
  };
}
